(function () {
  'use strict';

  // Mobile nav
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  // PDP gallery
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.dataset.full;
        main.alt = btn.dataset.alt || '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', String(b === btn));
        });
      });
    });
  });

  // Vehicle finder: marque -> modele -> motorisation
  document.querySelectorAll('[data-finder]').forEach(function (form) {
    var data;
    try { data = JSON.parse(form.querySelector('[data-finder-data]').textContent); } catch (e) { data = []; }
    var make = form.querySelector('[name=make]');
    var model = form.querySelector('[name=model]');
    var engine = form.querySelector('[name=engine]');
    var submit = form.querySelector('[type=submit]');

    function fill(sel, values, placeholder) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = placeholder;
      sel.appendChild(o);
      values.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v; opt.textContent = v;
        sel.appendChild(opt);
      });
      sel.disabled = values.length === 0;
    }
    function uniq(arr) { return arr.filter(function (v, i) { return v && arr.indexOf(v) === i; }).sort(); }

    fill(make, uniq(data.map(function (r) { return r.make; })), 'Marque');
    fill(model, [], 'Modele');
    fill(engine, [], 'Motorisation');
    if (submit) submit.disabled = true;

    make.addEventListener('change', function () {
      fill(model, uniq(data.filter(function (r) { return r.make === make.value; }).map(function (r) { return r.model; })), 'Modele');
      fill(engine, [], 'Motorisation');
      if (submit) submit.disabled = true;
    });
    model.addEventListener('change', function () {
      fill(engine, uniq(data.filter(function (r) { return r.make === make.value && r.model === model.value; }).map(function (r) { return r.engine; })), 'Motorisation');
      if (submit) submit.disabled = true;
    });
    engine.addEventListener('change', function () {
      if (submit) submit.disabled = !engine.value;
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = [make.value, model.value, engine.value].filter(Boolean).join(' ');
      var url = form.dataset.searchUrl || '/search';
      window.location.href = url + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
    });
  });

  // Cart quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (w) {
    var input = w.querySelector('input');
    w.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(b.dataset.step, 10));
        input.value = next;
        input.form && input.form.requestSubmit();
      });
    });
  });

  // Facet auto-submit
  document.querySelectorAll('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.requestSubmit(); });
  });
})();
